import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { errText } from "../lib/api";
import { toast } from "sonner";

const Auth = () => {
  const { login, register } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [mode, setMode] = useState("signin");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const p = new URLSearchParams(loc.search);
    if (p.get("mode") === "signup") setMode("signup");
  }, [loc.search]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === "signup") await register(name, email, password);
      else await login(email, password);
      toast.success("Welcome back to the atelier");
      nav("/studio");
    } catch (err) {
      toast.error(errText(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10 py-16 md:py-24 grid grid-cols-12 gap-10">
      <div className="col-span-12 md:col-span-6">
        <div className="font-mono-eyebrow mb-6">{mode === "signup" ? "Membership" : "Return visit"}</div>
        <h1 className="font-serif-display text-5xl md:text-7xl leading-none">
          {mode === "signup" ? <>Introduce<br/><em className="text-[color:var(--accent)]">yourself.</em></> : <>Welcome,<br/><em className="text-[color:var(--accent)]">again.</em></>}
        </h1>
        <p className="mt-8 max-w-md text-black/60 leading-relaxed">
          Your portraits and wardrobe stay in your account — visible only to you until
          you decide to share an outfit with the world.
        </p>
      </div>
      <div className="col-span-12 md:col-span-6">
        <div className="border border-black/10 bg-white/60 p-8 md:p-12 relative">
          <form onSubmit={submit} className="space-y-8">
            {mode === "signup" && (
              <div>
                <label className="font-mono-eyebrow">Full Name</label>
                <input data-testid="auth-name" required value={name} onChange={(e)=>setName(e.target.value)} className="field mt-2" placeholder="Jean Prouvé"/>
              </div>
            )}
            <div>
              <label className="font-mono-eyebrow">Email</label>
              <input data-testid="auth-email" required type="email" value={email} onChange={(e)=>setEmail(e.target.value)} className="field mt-2" placeholder="you@atelier.com"/>
            </div>
            <div>
              <label className="font-mono-eyebrow">Password</label>
              <input data-testid="auth-password" required type="password" value={password} onChange={(e)=>setPassword(e.target.value)} className="field mt-2" placeholder="••••••••"/>
              {/* Password reset flow is built but hidden until a Resend sender
                  domain is verified. Un-comment to re-enable. */}
              {/* {mode === "signin" && (
                <div className="mt-2 text-right">
                  <Link to="/forgot-password" data-testid="auth-forgot-link" className="editorial-link font-mono-eyebrow text-black/50 text-[10px]">
                    Forgot password?
                  </Link>
                </div>
              )} */}
            </div>
            <div className="flex items-center justify-between pt-4">
              <button type="button" data-testid="auth-toggle" onClick={()=>setMode(mode==="signup"?"signin":"signup")} className="editorial-link font-mono-eyebrow">
                {mode === "signup" ? "Already a member? Sign in" : "New here? Create an account"}
              </button>
              <button type="submit" data-testid="auth-submit" disabled={loading} className="btn-ink disabled:opacity-50">
                {loading ? "…" : (mode === "signup" ? "Join" : "Enter")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Auth;
